<h2 mat-dialog-title>{{ "components.input-dialog.title" | translate }}</h2>
<mat-dialog-content>
  <p>{{ text | translate }}</p>
  <mat-form-field class="input">
    <mat-label>{{ inputLabel | translate }}</mat-label>
    <input
      matInput
      id="input-dialog-input"
      aria-label="Input"
      #input
      [type]="data.type"
      [attr.inputmode]="getInputModeAttribute()"
      [formControl]="inputControl"
      (input)="updateErrorMessage()"
      (keyup.enter)="tryUpdate(input.value)"
    />
    @if (input.value !== "") {
      <button
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="inputControl.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    }

    @if (inputControl.invalid) {
      <mat-error>{{ errorMessage() | translate }}</mat-error>
    }
  </mat-form-field>

  <!-- this is a hack to make sure that even multi line error messages are displayed correctly -->
  <!-- I tried CSS and other things, but nothing really helped -->
  @if (inputControl.invalid && errorMessage() !== "") {
    <p style="clear: both"></p>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose>
    {{ "components.input-dialog.cancel" | translate }}
  </button>
  <button mat-button (click)="tryUpdate(input.value)">
    {{ "components.input-dialog.button" | translate }}
  </button>
</mat-dialog-actions>
